<template>
  <section
    class="layout-pt-lg layout-pb-lg"
   :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text_primary)'}`"
  >
    <div class="tw-container tw-mx-auto tw-px-4" style="max-width: 1280px;">
      <h2 class="tw-text-center tw-text-white tw-mb-16">{{vars.titleText}}</h2>
      
     
      <div class="tw-hidden lg:tw-flex tw-justify-center tw-gap-x-16 tw-px-4">
        <div
          v-for="(item, index) in items"
          :key="`item-desktop-${index}`"
          class="tw-flex tw-flex-col tw-items-center tw-text-center tw-w-full tw-max-w-lg"
        >
          <div class="tw-w-full tw-h-full tw-flex tw-flex-col">
            <div class="tw-w-full">
              <LibraryImage
                :src="item.image"
                class="tw-w-full"
                :w-ratio="15"
                :h-ratio="7"
                 
              />
              <div class="tw-mt-4 tw-text-center">
                <h6 class="tw-text-white">{{ item.accuracy }}</h6>
                <h3 class="tw-mt-4 tw-text-white">{{ item.title }}</h3>
              </div>
            </div>
            <div class="tw-flex-1 tw-flex tw-flex-col tw-w-full">
              <p  :style="`color: var(--c-${vars.textColor}) !important;`" class="tw-mt-6 tw-leading-relaxed tw-max-w-sm tw-mx-auto tw-mb-6">{{ item.description }}</p>
              <div class="tw-mt-auto">
                <nuxt-link
          :to="item.button_link"
          :class="['tw-w-auto', `n-${item.button_type}`]"
        >
          {{ item.button_label }}
        </nuxt-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      
     
      <div class="lg:tw-hidden tw-flex tw-flex-col tw-items-center tw-gap-y-16">
        <div
  v-for="(item, index) in items"
  :key="`item-mobile-${index}`"
  class="tw-flex tw-flex-col tw-items-center tw-text-center tw-w-full"
>
  <div class="tw-w-full tw-h-full tw-flex tw-flex-col">
    <div class="tw-w-full">
      <LibraryImage
        :src="item.image"
        class="tw-w-full"
        :w-ratio="15"
        :h-ratio="7"
      />
      <div class="tw-mt-4 tw-text-center">
        <h6 class="tw-text-white">{{ item.accuracy }}</h6>
        <h3 class="tw-mt-2 tw-text-white">{{ item.title }}</h3>
      </div>
    </div>
    <div class="tw-flex-1 tw-flex tw-flex-col tw-w-full">
      <p
        :style="`color: var(--c-${vars.textColor}) !important;`"
        class="tw-mt-3 tw-leading-relaxed tw-max-w-sm tw-mx-auto tw-mb-6"
      >
        {{ item.description }}
      </p>
      <div class="tw-mt-2">
        <nuxt-link
          :to="item.button_link"
          :class="['tw-w-auto', `n-${item.button_type}`]"
        >
          {{ item.button_label }}
        </nuxt-link>
      </div>
    </div>
  </div>
</div>

      </div>
    </div>
  </section>
</template>


<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'OurValuations',

  mixins: [ComponentMixin],

  
  
  computed: {
    items() {
      return this.groupedVariables.items;
    },
     buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>


